import { Stack, Typography } from "@mui/material";
import { Position } from "@xyflow/react";

import type { EventListenerRuleNode, RuleNodeProps } from "../types/nodes";
import AddConnectionHandle from "./AddConnectionHandle";
import AddHiddenHandle from "./AddHiddenHandle";
import BaseNode from "./BaseNode";

type EventListenerNodeProps = RuleNodeProps<EventListenerRuleNode>;

const EventListenerNode = (props: EventListenerNodeProps) => {
	const { data } = props;
	const targetCount = data.targetScreenFieldIds?.length ?? 0;

	return (
		<BaseNode {...props}>
			<Stack spacing={0.5}>
				<Typography variant="body2" color="text.primary">
					Number of Targets: {targetCount}
				</Typography>
			</Stack>
			<AddHiddenHandle type="target" position={Position.Top} id="in" />
			<AddConnectionHandle type="source" position={Position.Bottom} id="out" aria-label="Connect next step" />
		</BaseNode>
	);
};

export default EventListenerNode;
